<template>
  <div>
    <h4 v-if="userMailerLiteStatus === 0" class="text-title uppercase">{{$t('views.userdata.show.mailerLiteStatusNotAdded')}}</h4>
    <div class="pt-2 pb-1" v-for="userData in mailerLiteStatusData" v-bind:key="userData.id">
      <b-col class="pl-4 pr-4">
        <b-row>
          <b-col>
            <span>{{$t('global.nameAndSurname')}}</span>: <b>{{userData.name}}</b><br>
            <span>{{$t('views.userdata.show.userEmail')}}</span>: <b><a :href="'mailto: ' + userData.email">{{ userData.email }}</a></b><br>
            <span>{{$t('views.userdata.show.mailerLiteId')}}</span>: <b>{{userData.id}}</b><br>
            <span>{{$t('views.userdata.show.mailerLiteDateSubscribe')}}</span>: <b>{{userData.date_subscribe}}</b><br>
          </b-col>
          <b-col>
            <span>{{$t('views.userdata.show.mailerLiteStatus')}}</span>:
            <b v-if="userData.type === 'active'">{{$t('views.userdata.show.mailerLiteStatusActive')}}</b>
            <b v-else-if="userData.type === 'bounced'">{{$t('views.userdata.show.mailerLiteStatusBounced')}}</b>
            <b v-else-if="userData.type === 'unsubscribed'">{{$t('views.userdata.show.mailerLiteStatusUnsubscribed')}}</b>
            <b v-else-if="userData.type === 'junk'">{{$t('views.userdata.show.mailerLiteStatusJunk')}}</b>
            <b v-else-if="userData.type === 'unconfirmed'">{{$t('views.userdata.show.mailerLiteStatusUnconfirmed')}}</b><br>
            <span>{{$t('views.userdata.show.mailerLiteSent')}}</span>: <b>{{userData.sent}}</b><br>
            <span>{{$t('views.userdata.show.mailerLiteOpened')}}</span>: <b>{{userData.opened}}</b><br>
            <span>{{$t('views.userdata.show.mailerLiteClicked')}}</span>: <b>{{userData.clicked}}</b>
          </b-col>
        </b-row>
        <div v-if="userData.subscriberGroups.length > 0" class="mt-3">
          <h6 class="mt-2">{{$t('views.userdata.show.mailerLiteGroups')}}:</h6>
          <table class="table table-striped table-sm">
            <tr>
              <th class="text-left">{{$t('views.userdata.show.groupName')}}</th>
              <th>{{$t('views.excmmessages.list.createdAt')}}</th>
              <th>{{$t('views.userdata.show.inGroupsMembers')}}</th>
              <th>{{$t('buttons.options')}}</th>
            </tr>
            <tr v-for="(item, key) in userData.subscriberGroups" v-bind:key="key">
              <td class="text-left" :id="'mailerLiteGroup' + item.id">
                <i class="fa fa-eye text-success"></i>
                <b-popover custom-class="box-shadow shadow-sm bg-white rounded"
                           triggers="hover" placement="right" variant="secondary" :target="'mailerLiteGroup' + item.id">
                  <MailerLiteGroupInfo :idGroup="item.id"/>
                </b-popover>
                {{ item.name }}
              </td>
              <td>{{ item.date_created }}</td>
              <td>{{ item.active }}</td>
              <td>
                <b-button v-b-tooltip.hover :title="$t('views.userdata.show.deleteFromGroup')" @click="removeFromGroup(item.id, userData.email)" class="btn btn-sm btn-light">
                <i class="fa fa-trash"></i></b-button>
              </td>
            </tr>
          </table>
        </div>
      </b-col>
    </div>
    <button class="btn btn-info btn-circle float-right mb-2 mr-2" @click="$store.state.modals.userdata.addToMailerLite = { show: 1, selectedUsers: [getIdLink(data['@id'])]}" v-b-tooltip.hover :title="$t('views.userdata.list.autoAddMailerLiteSubscriber')"><i class="fal fas fa-mailbox"></i></button>
    <user-data-add-to-mailer-lite-modal @fetchMailerLiteStatusData="fetchMailerLiteStatusData"></user-data-add-to-mailer-lite-modal>
  </div>
</template>
<script>
import UserDataAddToMailerLiteModal from './userDataAddToMailerLiteModal'
import MailerLiteGroupInfo from '@/components/Dashboard/Views/userdata/component/MailerLite/mailerLiteGroupInfo'
import remove from '@/utils/remove'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'userDataMailerLiteBox',
  components: { MailerLiteGroupInfo, UserDataAddToMailerLiteModal },
  data () {
    return {
      userMailerLiteStatus: 0,
      mailerLiteStatusData: {}
    }
  },
  props: {
    data: {}
  },
  created () {
    this.fetchMailerLiteStatusData()
  },
  methods: {
    async deleteSingle (mailerLiteId) {
      await remove('mailerlitesubscribers/' + mailerLiteId, () => { this.fetchMailerLiteStatusData() })
    },
    async fetchMailerLiteStatusData () {
      const response = await new ApiService('mailerlitesubscribers/' + getId(this.data['@id'])).get()
      if (response.status === 207) {
        this.userMailerLiteStatus = 0
      } else if (response.status === 200) {
        this.mailerLiteStatusData = await response.json()
        if (this.mailerLiteStatusData.length > 0) {
          this.userMailerLiteStatus = 1
        }
      }
    },
    removeFromGroup (idGroup, idUserData) {
      this.$Swal({
        title: this.$t('buttons.confirmRemoveFromMailerLite'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(async (result) => {
        if (result) {
          const response = await new ApiService('delete/groups/' + idGroup + '/subscribers/' + idUserData).del()
          if (response) {
            this.fetchMailerLiteStatusData()
          }
        }
      })
    },
    getIdLink (link) {
      return getId(link)
    }
  }
}
</script>
